module.exports = __webpack_public_path__ + "img/feedback2.66f120e9.png";